export const environment = {
  production: false,
  base_url: 'https://ws-plataforma-toyota.toyosa-test.com/api/v1',
  base_url_servidor: 'https://ws-toyosa.toyosa-test.com',
  base_url_sucursales: 'https://ws-toyosa.toyosa-test.com/api/v2',
  base_url_v2: 'https://ws-plataforma-toyota.toyosa-test.com/api/v2',
  cardinal_url:'https://songbirdstag.cardinalcommerce.com/cardinalcruise/v1/songbird.js',
  cyberSourceID : '1snn5n9w'
};
